import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Tabs, Tab, Dialog } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Store } from '../Store';
import SignUp from '../screens/SignUp';

const MainFooter = ({ tabSel }) => {
  const { state } = useContext(Store);
  const history = useHistory();
  const [openSign, setOpenSign] = useState(false);

  let { setting } = state.userSetting;
  if (!setting) {
    setting = JSON.parse(localStorage.getItem("userInfo")) || {};
  }

  const handleTabChange = (event, newValue) => {
    // Handled by individual tab clicks for navigation
  };

  const goto = (subpath) => {
    history.push('/' + subpath + '?' + window.location.href.split('?')[1]);
  };

  const handleProfileClick = () => {
    const loggedIn = sessionStorage.getItem('customerInfo');
    if (loggedIn) {
      goto('profile');
    } else {
      setOpenSign(true);
    }
  };

  return (
    <>
      <Tabs
        style={{
          backgroundColor: setting.themeTxtColor,
          borderTop: "2px solid " + setting.themeColor,
          padding: "10px",
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          zIndex: 999999,
        }}
        className="footer-tab"
        value={tabSel}
        onChange={handleTabChange}
        aria-label="tabs footer"
      >
        <Tab
          style={{
            background: tabSel === 0 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel === 0 ? setting.themeTxtColor : ""
          }}
          onClick={() => goto('order')}
          icon={<HomeIcon />}
          label=""
        />
        <button style={{ border: 'none', background: 'transparent' }}></button>
        <Tab
          style={{
            width: "80px",
            height: "80px",
            position: "fixed",
            bottom: "9px",
            zIndex: "9",
            background: tabSel === 1 ? setting.themeTxtColor : setting.themeColor,
            borderRadius: "40px",
            opacity: "1",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
            border: "1px solid " + setting.themeColor
          }}
          onClick={() => goto('cart')}
          icon={
            <Box sx={{ position: 'relative', padding: '4px', }}>
              <ShoppingBasketIcon style={{ width: "40px", height: "40px", color: tabSel === 1 ? setting.themeColor : setting.themeTxtColor }} />
              {state.order.itemsCount > 0 && (
                <span className={"badge"} style={{ background: 'red', color: '#fff' }}>
                  {state.order.itemsCount}
                </span>
              )}
            </Box>
          }
          label=""
        />
        <Tab
          style={{
            background: tabSel === 2 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel === 2 ? setting.themeTxtColor : "",
            position: 'relative'
          }}
          onClick={handleProfileClick}
          icon={<AccountCircleIcon />}
          label=""
        />
      </Tabs>

      <Dialog
        onClose={() => setOpenSign(false)}
        open={openSign}
        fullWidth={true}
        maxWidth={'xs'}
      >
        <SignUp setOpenSign={setOpenSign} />
      </Dialog>
    </>
  );
};

export default MainFooter;
